import { pagesService } from "../_services";

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    nav: {
      list: [],
      status: status.INITIAL
    }
  },

  getters: {
    nav: ({ nav }) => nav.list,
    isNavLoaded: ({ nav }) => nav.status == status.LOADED, 
  },

  mutations: {
    setNav: ({ nav }, payload) => {
      nav.list = payload
    },
    setNavStatus: ({ nav }, status) => {
      nav.status = status
    },
  },
  actions: {
    INIT: ({ dispatch }) => {
        dispatch('LOAD_NAV')
    },
    LOAD_NAV: ({ state, commit }) => {
        if(state.nav.status == status.INITIAL ){
           commit('setNavStatus', status.LOADING)
           
           pagesService.loadTopNav().then(data => {
               if( data instanceof Array ) {
                   let page = data.filter(p => p.alias.indexOf(window.settings.cms.prefix) == 0)

                   commit('setNav', page)
                   commit('setNavStatus', status.LOADED)
               }
           })
        }
    },
  },

}